import { useState } from 'react'

export const useToggleModal = () => {
  const [modalState, setModalState] = useState(false)

  function toggleModalState() {
    setModalState((prev) => !prev)
  }
  return { modalState, toggleModalState }
}
export default useToggleModal
